import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
export default {
  data() {
    return {
      list: [],
      dialogVisible: false
    };
  },
  methods: {
    init(arr) {
      arr.map(item => {
        let obj = {};
        for (let key in item) {
          obj[key] = item[key];
        }
        this.list.push(obj);
      });
      this.dialogVisible = true;
    },
    handleSure() {
      console.log(this.list);
      this.$emit('ok', this.list);
      this.$emit('cancel');
    },
    onChange(e) {
      e.selected = !e.selected;
    }
  }
};